/**
 * @generated SignedSource<<2e6422835e2a359675b324535b39fa1d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OverviewInstagram_viewer$data = {
  readonly tradePortfolioInstagram: boolean | null;
  readonly " $fragmentType": "OverviewInstagram_viewer";
};
export type OverviewInstagram_viewer$key = {
  readonly " $data"?: OverviewInstagram_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"OverviewInstagram_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OverviewInstagram_viewer",
  "selections": [
    {
      "alias": "tradePortfolioInstagram",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "tradePortfolioInstagram"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"tradePortfolioInstagram\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "bb47bd6acf94096d35894a7a39f102d3";

export default node;
